<template>
  <div class="accident-list">
    <div class="maincontent">
      <component :is="header" @searchUpdata="searchUpdata" />

      <el-card class="table-wrapper">
        <el-link
          icon="el-icon-download"
          type="primary"
          class="export-link"
          @click="exportList"
        >
          导出
        </el-link>

        <component
          :is="listCom"
          :selected-accidents.sync="selectedAccidents"
          :table-data="tableData"
          :loading="loading"
          :pagination.sync="pagination"
          @refresh="getUserInfoToShow"
          @pagination="getUserInfoToShow"
        />
      </el-card>
    </div>
  </div>
</template>

<script>
const loginType = localStorage.getItem('loginType')

import fileDownload from "js-file-download";
import Pagination from "@/components/Pagination";
import { getAccidentList, exportAccidentList, getMediatorList } from "@/api/accident/list";
// import AccidentList from "@/components/AccidentList.vue";
import DictSelect from "../components/dict-select.vue";
import RemoteListHeader from "./components/RemoteListHeader.vue";
import DirectListHeader from "./components/DirectListHeader.vue";
import VehicleListHeader from "./components/VehicleListHeader.vue";
import store from "@/store";
import { req } from "@/api/accident/list";
import commonAccidentListCom from "../../../components/commonAccidentListCom.vue";
import carAccidentListCom from "../../../components/carAccidentListCom.vue";
import hospitalAccidentListCom from "../../../components/hospitalAccidentListCom.vue";
import mediatorAccidentListCom from "../../../components/mediatorAccidentListCom.vue";

export default {
  components: {
    Pagination,
    DictSelect,
    RemoteListHeader,
    DirectListHeader,
    VehicleListHeader,
    commonAccidentListCom,
    carAccidentListCom,
    hospitalAccidentListCom,
    mediatorAccidentListCom
  },
  data() {
    return {
      query: { accidentStartDate: "", accidentEndDate: "" },
      tableData: [],
      total: 0,
      isUnfold: false,
      loading: false,
      header: "",
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      loginType: loginType,
      listCom: "commonAccidentListCom",
      selectedAccidents: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      dictMap: { accident_status: {}, case_deal_type: {} },
    };
  },
  mounted() {},
  computed: {
    accidentDate: {
      get() {
        return [this.query.accidentStartDate || "", this.query.accidentEndDate || ""];
      },
      set(value) {
        if (Array.isArray(value)) {
          const [startDate, endDate] = value;
          this.query.accidentStartDate = startDate;
          this.query.accidentEndDate = endDate;
        } else {
          this.query.accidentStartDate = null;
          this.query.accidentEndDate = null;
        }
      },
    },
  },
  created() {
    this.getSearchTime();
    this.getNeedDicts();
    this.getUserInfoToShow();
  },
  methods: {
    searchUpdata(data) {
      this.tableData = data.list;
      this.pagination.total = data.total;
    },
    // 导出列表
    async exportList() {
      const data = await exportAccidentList(
        {
          ...this.query,
          accidentIds: this.selectedAccidents.map(({ accidentId }) => accidentId),
        },
        this.pagination
      );
      fileDownload(data, "事故列表.xlsx");
    },
    getNeedDicts() {
      this.getDicts(Object.keys(this.dictMap)).then((data) => {
        this.dictMap = Object.keys(this.dictMap).reduce((acc, dictType) => {
          acc[dictType] = data[dictType].reduce((map, { dictLabel, dictValue }) => {
            map[dictValue] = dictLabel;
            return map;
          }, {});
          return acc;
        }, {});
      });
    },
    // 获取用户的权限信息,用来判断加载不同的搜索组件和列表组件
    async getUserInfoToShow() {
      let roleString = "";
      this.loading = true;
      let res = {};
      const { total, ...params } = this.pagination;
      if (
        store.state.user.roles.includes("TrafficPolice") ||
        store.state.user.roles.includes("Agent") ||
        store.state.user.roles.includes("admin")
      ) {
        if(loginType == '3185') {
          roleString = "Mediator";
        }else {
          roleString = "Admin";
        }

      } else if (store.state.user.roles.includes("Insurance")) {
        // 保险
        roleString = "Insurance";
      } else if (store.state.user.roles.includes("Hospital")) {
        // 医院
        roleString = "Hospital";
      } else if (store.state.user.roles.includes("Mediator")) {
        // 调解
        roleString = "Mediator";
      }else if (store.state.user.roles.includes("Trailer")) {
        // 拖车
        roleString = "Trailer";
      } else if (store.state.user.roles.includes("Repair")) {
        // 修车
        roleString = "Repair";
      } else if (store.state.user.roles.includes("Offline")) {
        roleString = "Offline";
      } else {
        roleString = "Other";
      }

      switch (roleString) {
        case "Admin":
          this.header = "RemoteListHeader";
          this.listCom = "commonAccidentListCom";
          res = await getAccidentList(this.$store.state.app.searchCondition, params);
          this.pagination.total = res.data.total;
          this.tableData = res.data.list;
          this.loading = false;
          console.log("Admin");
          break;
        case "Insurance":
          this.header = "RemoteListHeader";
          this.listCom = "commonAccidentListCom";
          req("/accident/list", "get", params)
            .then((res) => {
              this.pagination.total = res.data.total;
              this.tableData = res.data.list;
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
          console.log("Insurance");
          break;
        case "Hospital":
          this.header = "DirectListHeader";
          this.listCom = "hospitalAccidentListCom";
          res = await getAccidentList(
            this.$store.state.app.searchCondition,
            this.pagination
          );
          this.pagination.total = res.data.total;
          this.tableData = res.data.list;
          this.loading = false;
          console.log("Hospital");
          break;
        case "Mediator":
          this.header = "DirectListHeader";
          this.listCom = "mediatorAccidentListCom";
          res = await getMediatorList(
            this.$store.state.app.searchCondition,
            this.pagination
          );
          this.pagination.total = res.data.total;
          this.tableData = res.data.list;
          this.loading = false;
          console.log("Mediator");
          break;
        case "Trailer":
          this.header = "VehicleListHeader";
          this.listCom = "carAccidentListCom";
          res = await getAccidentList(
            this.$store.state.app.searchCondition,
            this.pagination
          );
          this.pagination.total = res.data.total;
          this.tableData = res.data.list;
          this.loading = false;
          console.log("Trailer");
          break;
        case "Repair":
          this.header = "VehicleListHeader";
          this.listCom = "carAccidentListCom";
          res = await getAccidentList(
            this.$store.state.app.searchCondition,
            this.pagination
          );
          this.pagination.total = res.data.total;
          this.tableData = res.data.list;
          this.loading = false;
          console.log("Repair");
          break;
        case "Offline":
          await req("/accident/list", "get", params)
            .then((res) => {
              this.pagination.total = res.data.total;
              this.tableData = res.data.list;
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
          console.log("Offline");
          break;
        default:
          this.header = "RemoteListHeader";
          this.listCom = "commonAccidentListCom";
          console.log("角色判断出错,检查一下!");
          break;
      }
    },
    getSearchTime() {
      let time1 = new Date();
      let time2 = new Date(time1.getTime() - 604800000);
      let mounth1 = time1.getMonth() + 1;
      mounth1 = mounth1 > 9 ? mounth1 : "0" + mounth1;
      let day1 = time1.getDate() > 9 ? time1.getDate() : "0" + time1.getDate();
      let mounth2 = time2.getMonth() + 1;
      mounth2 = mounth1 > 9 ? mounth2 : "0" + mounth2;
      let day2 = time2.getDate() > 9 ? time2.getDate() : "0" + time2.getDate();
      this.query.accidentEndDate =
        time1.getFullYear() + "-" + mounth1 + "-" + day1 + " 00:00:00";
      this.query.accidentStartDate =
        time2.getFullYear() + "-" + mounth2 + "-" + day2 + " 00:00:00";
      this.$store.commit("app/SET_SEARCHCONDITION", { ...this.query, accidentId: "" });
    },
  },
};
</script>

<style lang="scss" scoped>
.accident-list {
  position: relative;
  height: 1169px;
  // background-color: pink;
  .maincontent {
    height: 1156px;
    margin-top: 13px;
    // background-color: red;
    .changlistbtns {
      width: 220px;
      height: 70px;
      display: flex;
      justify-content: space-between;
      .commonbtn {
        width: 200px;
        height: 68px;
        border: 1px solid #0084ff;
        color: #b1e3ff;
        font-size: 20px;
        display: flex;
        flex-direction: column;
        background-image: linear-gradient(#010345, #0d2c60);
        & > {
          line-height: 50px;
        }
      }
      .selectedbtn {
        height: 81px;
        color: #0ebd35;
      }
    }
  }
  .table-wrapper {
    position: relative;
    z .export-link {
      z-index: 10;
      position: absolute;
      right: 30px;
      top: 25px;
    }
  }

  .ang1 {
    position: absolute;
    top: -3px;
    left: -3px;
  }
  .ang2 {
    position: absolute;
    top: -3px;
    right: -3px;
  }
  .ang3 {
    position: absolute;
    bottom: -3px;
    left: -3px;
  }
  .ang4 {
    position: absolute;
    bottom: -3px;
    right: -3px;
  }
}
</style>
